import {
  IonFab,
  IonFabButton,
  IonIcon,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonList,
  IonPopover,
  useIonToast,
  IonSkeletonText,
} from "@ionic/react";
import { add, ellipsisVerticalOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useList } from "react-firebase-hooks/database";
import { useFirebase } from "../components/firebase-provider";
import PageLayout from "../components/layout";

const Product: React.FC = () => {
  const [toast] = useIonToast();
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
    id: "",
    sku: [],
  });

  const { database } = useFirebase();
  const [snapshot, loading] = useList(database.ref("product"));

  const [productList, setProductList] = useState<any>([]);

  useEffect(() => {
    if (snapshot) {
      setProductList(snapshot);
    }
  }, [snapshot]);

  // popover
  const hidePopOver = () => {
    setShowPopover({ showPopover: false, event: undefined, id: "", sku: [] });
  };

  // DelProduct
  const handleDel = (id: string, sku?: Array<string>) => async () => {
    const delProduct = database.ref("/product/" + id).set(null);
    const delSku = sku?.forEach((x) => {
      database.ref("/stock/" + x).set(null);
    });

    await Promise.all([delProduct, delSku])
      .then(() => {
        toast({
          message: "Varian berhasil dihapus",
          duration: 1000,
          color: "danger",
          position: "top",
        });
      })
      .catch(() => {
        toast({
          message: "Product gagal dihapus",
          duration: 1000,
          color: "warning",
          position: "top",
        });
      });

    hidePopOver();
  };

  return (
    <PageLayout title="Atur Produk">
      
        <IonItemGroup>
          {loading && Array.from({ length: 5 }).map((el, i) => (
            <React.Fragment key={i}>
              <IonItem>
                <IonLabel>
                  <IonSkeletonText animated style={{ width: "10em" }} />
                  <p>
                    <IonSkeletonText animated style={{ width: "5em" }} />
                  </p>
                </IonLabel>
                <IonLabel>
                  <p>
                    <IonSkeletonText animated style={{ width: "4em" }} />
                  </p>
                </IonLabel>
                <IonIcon
                  title="Edit"
                  icon={ellipsisVerticalOutline}
                  slot="end"
                />
              </IonItem>
            </React.Fragment>
          ))}

          {!loading && productList.map((e: any) => {
            const val = {
              nama: e?.val()?.product_name,
              merk: e?.val()?.brand,
              total: e?.val()?.varian?.length,
              sku: e?.val()?.varian?.map((vr: any) => vr.sku),
            };
            return (
              <React.Fragment key={e.key}>
                <IonItem>
                  <IonLabel>
                    {val.nama}
                    <p>{val.merk}</p>
                  </IonLabel>
                  <IonLabel>
                    <p>{val.total} Varian</p>
                  </IonLabel>
                  <IonIcon
                    title="Edit"
                    icon={ellipsisVerticalOutline}
                    slot="end"
                    onClick={(el: any) => {
                      el.persist();
                      setShowPopover({
                        showPopover: true,
                        event: el,
                        id: e.key,
                        sku: val.sku,
                      });
                    }}
                  />
                </IonItem>
              </React.Fragment>
            );
          })}
        </IonItemGroup>
      

      {/* POPOVER */}
      <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={hidePopOver}
      >
        <IonList>
          <IonItem
            button
            routerLink={`/app/product/edit/${popoverState.id}`}
            onClick={hidePopOver}
          >
            Edit
          </IonItem>
          <IonItem button>
            <IonLabel
              color="danger"
              onClick={handleDel(popoverState.id, popoverState.sku)}
            >
              Hapus
            </IonLabel>
          </IonItem>
          <IonItem lines="none" detail={false} button onClick={hidePopOver}>
            Tutup
          </IonItem>
        </IonList>
      </IonPopover>

      <IonFab horizontal="end" vertical="bottom" slot="fixed">
        <IonFabButton color='secondary' routerLink="/app/product/add">
          <IonIcon icon={add} title="Tambah Produk Baru" />
        </IonFabButton>
      </IonFab>
    </PageLayout>
  );
};

export default Product;
